import { uploadUri } from '../appConfig';

const restaurantTypeIconMapping = {
	cafe: document.querySelector('._template-block > .cafe-icon > svg'),
	chinese: document.querySelector('._template-block > .chinese-icon > svg'),
	meeting: document.querySelector('._template-block > .meeting-icon > svg'),
	pavilion: document.querySelector('._template-block > .pavilion-icon > svg'),
	restaurant: document.querySelector('._template-block > .restaurant-icon > svg'),
	wedding: document.querySelector('._template-block > .wedding-icon > svg'),
};

const addSlide = (imageUrl) => {
	const slider = document.createElement('div');
	slider.classList.add('swiper-slide');
	slider.setAttribute(
		'style',
		`background-image: url(${imageUrl})`,
	);

	return slider;
};

const renderMenu = (element, information, type = 'menu') => {
	element.querySelector(`.detail-block > .content > .subtitle.-${type}`)
		.classList.add('-show');

	let info = '';
	information.forEach((item) => {
		info = `${
			info ? `${info}·` : ''
		}<a target='_blank' href='${
			type === 'menu' ? item.url : `${uploadUri}/${item.url}`
		}'>${
			item.name
		}</a>`;
	});

	/**
	 * add menu under the subtitle
	 */
	element.querySelector(`.detail-block > .content > .subtitle.-${type}`).insertAdjacentHTML('afterend', info);
};

const renderRestaurantSection = (restaurant, even) => {
	const template = document.querySelector('._template-block > .restaurant-section').cloneNode(true);

	/**
	 * add photos into .swiper-wrapper
	 */
	restaurant.photo.forEach((image) => {
		template.querySelector('.swiper-container > .swiper-wrapper').appendChild(
			addSlide(`${uploadUri}/${image}`),
		);
	});

	/**
	 * right variant class
	 */
	if (even) {
		template.classList.add('-right');
	}

	/**
	 * information
	 */
	template.querySelector('._link-flag').setAttribute('id', restaurant.id);
	template.querySelector('.intro-block > .icon').appendChild(
		restaurantTypeIconMapping[restaurant.restaurant_type].cloneNode(true),
	);
	template.querySelector('.intro-block > .title').innerText = restaurant.name;
	template.querySelector('.intro-block > .content').innerText = restaurant.introduction_title;

	/**
	 * detail information
	 */
	let information = '';
	restaurant.information.forEach((item) => {
		information += `<div class="subtitle">${item.name}</div>`;
		let content = '';
		item.content.forEach((info) => {
			content += `${info}<br/>`;
		});
		information += `<div class="plaintext">${content}</div>`;
	});
	template.querySelector('.detail-block > .content').insertAdjacentHTML('afterbegin', information);

	if (restaurant.maps.length) {
		renderMenu(template, restaurant.maps, 'map');
	}
	if (restaurant.menu.length) {
		renderMenu(template, restaurant.menu);
	}

	return template;
};

export default renderRestaurantSection;



// WEBPACK FOOTER //
// ./src/js/restaurant/renderRestaurantSection.js